module.exports = __webpack_public_path__ + "bad7d52e4439ee3c2f6377e93ccd3b93.svg";